// How money and dates read across the console — the same way the app writes
// them, so a figure looks alike on both.

const rupees = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
const rupeesRounded = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  maximumFractionDigits: 0,
});

/** ₹1,23,456.78 */
export const money = (value) => rupees.format(Number(value) || 0);

/** ₹1,23,457 — for headline figures, where paise are noise. */
export const moneyRounded = (value) => rupeesRounded.format(Number(value) || 0);

const asDate = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const date = value instanceof Date ? value : new Date(typeof value === "string" && /^\d+$/.test(value) ? Number(value) : value);
  return Number.isNaN(date.getTime()) ? null : date;
};

/** 29 Oct 2026 */
export const date = (value) => {
  const d = asDate(value);
  return d ? d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "—";
};

/** 29 Oct 2026, 10:30 */
export const dateTime = (value) => {
  const d = asDate(value);
  return d
    ? d.toLocaleString("en-GB", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" })
    : "—";
};

/** October 2026 */
export const monthYear = (value) => {
  const d = asDate(value);
  return d ? d.toLocaleDateString("en-GB", { month: "long", year: "numeric" }) : "—";
};

/** 1 Oct */
export const dayMonth = (value) => {
  const d = asDate(value);
  return d ? d.toLocaleDateString("en-GB", { day: "numeric", month: "short" }) : "—";
};

/** 1st, 2nd, 23rd — for a due day. */
export const ordinal = (day) => {
  if (day >= 11 && day <= 13) return `${day}th`;
  return `${day}${{ 1: "st", 2: "nd", 3: "rd" }[day % 10] || "th"}`;
};

/** "2026-10" → the first day of that month. */
export const parsePeriod = (period) => {
  const match = /^(\d{4})-(\d{2})$/.exec(period || "");
  return match ? new Date(Number(match[1]), Number(match[2]) - 1, 1) : null;
};

/** A person's name from a member record. */
export const fullName = (member) =>
  [member?.first_name, member?.last_name].filter(Boolean).join(" ") || member?.email || "Unknown member";

/** The message a failed request carries, or a fallback fit to show. */
export const errorMessage = (error, fallback = "Something went wrong. Try again.") =>
  error?.response?.data?.message || error?.response?.data?.data || fallback;
